import { Box, Paper, Typography } from "@mui/material";

interface IStatTileProps {
	label: string;
	value: number;
	color?: "success.main" | "error.main" | "warning.main" | "info.main" | "text.primary" | "text.secondary";
}

export const StatTile = ({ label, value, color = "text.primary" }: IStatTileProps) => (
	<Paper
		variant="outlined"
		sx={{
			flex: "1 1 120px",
			minWidth: 110,
			p: 1.5,
			textAlign: "center",
			borderTop: 3,
			borderTopColor: color,
		}}
	>
		<Typography variant="h5" color={color} fontWeight="bold">
			{value}
		</Typography>
		<Typography variant="caption" color="text.secondary">
			{label}
		</Typography>
	</Paper>
);
